let menuData = {
  default: {
    url: 'https://cdnvue.gymcity.com.cn/uploads/38b1febf45a7a6d19afcb713112a507d.png'
  },
  2: {
    url: 'https://cdnvue.gymcity.com.cn/uploads/11899349688fe83524052bd88e41042c.png',
    totalCount: 14712
  },
  3: {
    url: 'https://cdnvue.gymcity.com.cn/uploads/b524b8913593888614d912a08ef9c503.png',
    addCount: 84
  },
  1: {
    url: 'https://cdnvue.gymcity.com.cn/uploads/33f8f2ab7f5f2c41c76552c2aaf651cf.png'
  },
  4: {
    url: 'https://cdnvue.gymcity.com.cn/uploads/d4a6b2397014759a3868c7d315605b5e.png'
  },
  wdsc: {
    icon: 'https://cdnvue.gymcity.com.cn/uploads/dd10e22eade1a52956c060337fea500f.png'
  },
  16: {
    url: 'https://cdnvue.gymcity.com.cn/uploads/ac301533c44412fce48914b8696b2e9d.png'
  },
  113: {
    url: 'https://cdnvue.gymcity.com.cn/uploads/74e035960a3e1ae772a0b27a16e443f7.png',
    check_url: 'https://member3.gymcity.com.cn/#/track-hot-list',
    addCount: 84
  },
  127: {
    url: 'https://cdnvue.gymcity.com.cn/uploads/eb556b0696933bae39c259905dc2859b.png',
    check_url: 'https://member3.gymcity.com.cn/#/inner-rank'
  },
  135: {
    url: 'https://cdnvue.gymcity.com.cn/uploads/eb556b0696933bae39c259905dc2859b.png',
    check_url: 'https://member3.gymcity.com.cn/#/vertical-video-rank'
  },
  150: {
    check_url: '/data-report'
  }
}
export { menuData }
